import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class CashbackInfo extends Vue {

  @Getter getUniversityVariables: any
  @Getter getUser: any
  @Getter getCountry: any
  @Getter getWallet: any

  get getCashbackPercent () {
    const variables = this.getUniversityVariables
    if (variables.length) {
      const percent = this.getUniversityVariables.filter((item) => item.name === 'cashback_percent')
      return percent[0].value
    } else {
      return 0
    }
  }

  get getCashbackRefererPercent () {
    const variables = this.getUniversityVariables
    if (variables.length) {
      const percent = this.getUniversityVariables.filter((item) => item.name === 'cashback_referer_percent')
      return percent[0].value
    } else {
      return 0
    }
  }

  get getCashbackTotal () {
    const cashback = this.getWallet.cashback_total
    if (cashback && this.getCountry && this.getCountry.language !== null) {
      return cashback.toLocaleString(this.getCountry.language, { style: 'currency', currency: this.getCountry.currency });
    } else {
      return 0
    }
  }

  get getCashbackEnabled () {
    const variables = this.getUniversityVariables
    if (variables.length) {
      const percent = variables.filter((item) => item.name === 'cashback_enabled')
      return JSON.parse(percent[0].value)
    } else {
      return false
    }
  }

}
